import React, { useEffect, useContext, useState, useRef } from "react";

//jQuery initialization
import $ from "jquery";

//functions
import {
  _t,
  managePageHrefLink,
  managePageHrefLinkMobile,
  checkPermission,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";

const ReportSidebar = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [matchCount, setMatchCount] = useState(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    handleJquery();
    // Record initially active category so clearing search can restore it
    $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
      if ($(this).hasClass("active")) {
        $(this).attr("data-default-active", "true");
      }
    });
  }, []);

  const { showManageStock, generalSettings } = useContext(SettingsContext);
  let { authUserInfo } = useContext(UserContext);

  // Real-time search filter effect
  useEffect(() => {
    const term = searchTerm.toLowerCase().trim();

    if (!term) {
      // Restore all categories and sub-items
      $(".fk-pos-nav > .fk-pos-nav__list").show();
      $(".fk-pos-nav__sub-list").show();
      $(".fk-sm-nav__bar > .fk-sm-nav__list").show();
      $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
        if ($(this).attr("data-default-active") === "true") {
          $(this).addClass("active").find(".fk-pos-nav__sub").show();
        } else {
          $(this).removeClass("active").find(".fk-pos-nav__sub").hide();
        }
      });
      setMatchCount(null);
      return;
    }

    let count = 0;

    // Filter large screen categories and sub-items
    $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
      const $category = $(this);
      const catName = $category.children("a").text().toLowerCase();
      const isCatMatch = catName.includes(term);

      let categoryHasMatches = false;

      $category.find(".fk-pos-nav__sub-list").each(function () {
        const $item = $(this);
        const itemText = $item.text().toLowerCase();

        if (isCatMatch || itemText.includes(term)) {
          $item.show();
          categoryHasMatches = true;
          count++;
        } else {
          $item.hide();
        }
      });

      if (categoryHasMatches || isCatMatch) {
        $category.show().addClass("active");
        $category.find(".fk-pos-nav__sub").show();
      } else {
        $category.hide();
      }
    });

    // Filter small screen (mobile) items
    $(".fk-sm-nav__bar > .fk-sm-nav__list").each(function () {
      const $item = $(this);
      const itemText = $item.text().toLowerCase();
      if (itemText.includes(term)) {
        $item.show();
      } else {
        $item.hide();
      }
    });

    setMatchCount(count);
  }, [searchTerm]);

  //jQuery goes here
  const handleJquery = () => {
    var posHasSub = $(".fk-pos-nav__list-has-sub");
    var posSub = $(".fk-pos-nav__sub");
    $(".fk-pos-nav__list-has-sub > a").on("click", function (e) {
      e.preventDefault();
    });
    posHasSub.on("click", function () {
      $(this).find(posSub).slideDown();
      $(this).siblings().find(posSub).slideUp();
      $(this).addClass("active").siblings().removeClass("active");
      // Update default active when user clicks manually
      $(this).attr("data-default-active", "true").siblings().removeAttr("data-default-active");
    });
  };

  const hasDashboardPermission = authUserInfo &&
  authUserInfo.details?.user_type !== "superAdmin" &&
  authUserInfo.details?.user_type !== "admin"
    ? checkPermission(authUserInfo.permissions, "Dashboard")
    : true;
    
  const hasTableViewPermission = authUserInfo &&
  authUserInfo.details?.user_type !== "superAdmin" &&
  authUserInfo.details?.user_type !== "admin"
    ? checkPermission(authUserInfo.permissions, "Table View")
    : true;

  const renderSearchBar = (isMobile = false) => (
    <div className={`report-sidebar-search-box ${isMobile ? "mb-3" : "mb-2"}`}>
      <div className="report-sidebar-search-wrapper">
        <span className="report-sidebar-search-icon">
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          ref={isMobile ? null : searchInputRef}
          type="text"
          className="form-control report-sidebar-search-input"
          placeholder={_t(t("Search reports..."))}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setSearchTerm("");
            }
          }}
        />
        {searchTerm && (
          <button
            type="button"
            className="report-sidebar-search-clear"
            onClick={() => {
              setSearchTerm("");
              if (!isMobile && searchInputRef.current) {
                searchInputRef.current.focus();
              }
            }}
            title={_t(t("Clear search"))}
          >
            <i className="fa fa-times-circle" aria-hidden="true"></i>
          </button>
        )}
      </div>
      {searchTerm.trim() && (
        <div className="report-sidebar-search-meta d-flex justify-content-between align-items-center mt-1 px-1">
          <span className="badge badge-light report-sidebar-badge">
            {matchCount !== null && (
              <>
                {matchCount}{" "}
                {matchCount === 1 ? _t(t("report found")) : _t(t("reports found"))}
              </>
            )}
          </span>
          <button
            type="button"
            className="btn btn-link p-0 report-sidebar-clear-link"
            onClick={() => setSearchTerm("")}
          >
            {_t(t("Clear"))}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <>
      <style>{`
        .report-sidebar-search-box {
          position: relative;
          width: 100%;
        }
        .report-sidebar-search-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1.5px solid #d1d5db;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          overflow: hidden;
        }
        .report-sidebar-search-wrapper:focus-within {
          border-color: #0a8d6e;
          box-shadow: 0 0 0 3px rgba(10, 141, 110, 0.15);
        }
        .report-sidebar-search-icon {
          position: absolute;
          left: 11px;
          color: #0a8d6e;
          font-size: 13px;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }
        .report-sidebar-search-input {
          width: 100% !important;
          height: 38px !important;
          border: none !important;
          background: transparent !important;
          padding-left: 33px !important;
          padding-right: 30px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .report-sidebar-search-input::placeholder {
          color: #94a3b8 !important;
          font-size: 12.5px !important;
        }
        .report-sidebar-search-clear {
          position: absolute;
          right: 8px;
          background: transparent;
          border: none;
          color: #94a3b8;
          padding: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 1;
          z-index: 2;
          transition: color 0.15s ease;
        }
        .report-sidebar-search-clear:hover {
          color: #ef4444;
        }
        .report-sidebar-badge {
          background-color: #e6f4ea !important;
          color: #0a8d6e !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          padding: 3px 8px !important;
          border-radius: 12px !important;
        }
        .report-sidebar-clear-link {
          font-size: 11px !important;
          color: #64748b !important;
          text-decoration: none !important;
        }
        .report-sidebar-clear-link:hover {
          color: #ef4444 !important;
          text-decoration: underline !important;
        }
        .report-sidebar-scroll {
          height: calc(100vh - 170px) !important;
          max-height: calc(100vh - 170px) !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          scrollbar-width: thin !important;
          scrollbar-color: rgba(0, 0, 0, 0.25) transparent !important;
        }
        .report-sidebar-scroll::-webkit-scrollbar {
          width: 6px !important;
        }
        .report-sidebar-scroll::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .report-sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.2) !important;
          border-radius: 4px !important;
        }
        .report-sidebar-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.35) !important;
        }
      `}</style>

      {/* Navigation for Small Screen  */}
      <div className="d-lg-none">
        <div className="row">
          <div className="col-12">
            {renderSearchBar(true)}
            <div className="fk-sm-nav" data-simplebar>
              {/* Reports */}
              <ul className="t-list fk-sm-nav__bar flex-row">
                {/* dashboard */}
                {hasDashboardPermission && (
                  managePageHrefLinkMobile(
                    "/dashboard/reports",
                    _t(t("Dashboard"))
                  )
                )}

                {hasTableViewPermission && (
                    managePageHrefLinkMobile(
                    "/dashboard/table-view",
                    _t(t("Table View"))
                  )
                )}

                {
                  authUserInfo && (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") && (
                    managePageHrefLinkMobile(
                      "/dashboard/admin-reports",
                      _t(t("Admin Dashboard"))
                    )
                  )
                }

                {
                  authUserInfo?.details && (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") && (
                    managePageHrefLinkMobile(
                      "/dashboard/costing-reports",
                      _t(t("Costing Dashboard"))
                    )
                  )
                }
                  
                {authUserInfo?.details && authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" ? (
                  <>
                    {/*production dashboard */}
                    {authUserInfo && (authUserInfo.details.user_type === "superAdmin" ||
                      authUserInfo.details.user_type === "admin") && managePageHrefLinkMobile(
                      "/dashboard/production-dashboard",
                      _t(t("Production Dashboard"))
                    )}

                    {/*consolited dashboard */}
                    {authUserInfo && authUserInfo.details.user_type === "superAdmin" &&
                      getSystemSettings(generalSettings, "call_api") === "yes" && managePageHrefLinkMobile(
                      "/dashboard/consolidated-reports",
                      _t(t("Consolidate Dashboard"))
                    )}

                    {/*consolited dashboard */}
                    {authUserInfo && authUserInfo.details.user_type === "superAdmin" &&
                      getSystemSettings(generalSettings, "call_api") === "yes" && managePageHrefLinkMobile(
                      "/dashboard/consolidate-reports",
                      _t(t("Consolidate Report"))
                    )}

                    {/* daily */}
                    {/* {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Daily Report")
                      ? managePageHrefLinkMobile(
                          "/dashboard/daily-reports",
                          _t(t("Daily"))
                        )
                      : ""} */}

                    {/* monthly */}
                    {/* {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Monthly Report")
                      ? managePageHrefLinkMobile(
                          "/dashboard/monthly-reports",
                          _t(t("Monthly"))
                        )
                      : ""} */}
                  </>
                ) : null}

                {/* monthly */}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Work Period Report")
                  ? managePageHrefLinkMobile(
                      "/dashboard/work-period-reports",
                      _t(t("Work Period Report"))
                    )
                  : ""}
                {/* monthly */}
                {authUserInfo.permissions !== null &&
                 checkPermission(authUserInfo.permissions, "Sales Report")
                  ? managePageHrefLinkMobile(
                      "/dashboard/sales-reports",
                      _t(t("Sales Report"))
                    )
                  : ""}
                {/* monthly */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Summary Report"
                  )
                  ? managePageHrefLinkMobile(
                      "/dashboard/sales-summary-reports",
                      _t(t("Sales Summary Report"))
                    )
                  : ""}

                {/* weekly sales report */}
                 {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Summary Report"
                  )
                  ? managePageHrefLinkMobile(
                      "/dashboard/weekly-sales-reports",
                      _t(t("Weekly Sales Report"))
                    )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Foc Report"
                  )
                  ? managePageHrefLinkMobile(
                      "/dashboard/foc-reports",
                      _t(t("Foc Report"))
                    )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions,"Sales Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/sales-analysis-reports",
                    _t(t("Sales Analysis Report"))
                  )
                  : ""}

                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Gross Sales Report"
                  )
                  ? managePageHrefLinkMobile(
                      "/dashboard/gross-sales-reports",
                      _t(t("Gross Sales Report"))
                    )
                  : ""}
                  
                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Tax Report"
                  )
                  ? managePageHrefLinkMobile(
                      "/dashboard/tax-sales-reports",
                      _t(t("Tax Report"))
                    )
                  : ""}

                  {/* monthly */}
                  {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Order Tracking Report")
                    ? managePageHrefLinkMobile(
                        "/dashboard/order-tracking-reports",
                        _t(t("Order Tracking Report"))
                      )
                    : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "Deals Report"
                    )
                      ? managePageHrefLinkMobile(
                          "/dashboard/deal-reports",
                          _t(t("Deal's Report"))
                        )
                      : ""}
                  
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Menu Mix Report"
                  )
                  ? managePageHrefLinkMobile(
                    "/dashboard/menu-mix-reports",
                    _t(t("Menu Mix Report"))
                  )
                  : ""}


                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "Callcenter Report"
                    )
                    ? managePageHrefLinkMobile(
                        "/dashboard/call-center-reports",
                        _t(t("Call Center Report"))
                      )
                    : ""}

                  {/* monthly */}
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Source Wise Report")
                    ? managePageHrefLinkMobile(
                        "/dashboard/source-reports",
                        _t(t("Source Wise Report"))
                      )
                    : ""}
                  {/* monthly */}
                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Customer Order History Report"
                  )
                    ? managePageHrefLinkMobile(
                        "/dashboard/customer-order-reports",
                        _t(t("Customer Order Report"))
                      )
                    : ""}
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Food Panda Report")
                    ? managePageHrefLinkMobile(
                        "/dashboard/food-panda-reports",
                        _t(t("Food Panda Report"))
                      )
                    : ""}
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Feedback Report")
                    ? managePageHrefLinkMobile(
                        "/dashboard/feedback-reports",
                        _t(t("Feedback Report"))
                      )
                    : ""}  
                  {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Rider Report")
                      ? managePageHrefLinkMobile(
                          "/dashboard/rider-reports",
                          _t(t("Rider Report"))
                        )
                      : ""}
                  {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Waiter Report")
                      ? managePageHrefLinkMobile(
                          "/dashboard/waiter-reports",
                          _t(t("Waiter Report"))
                        )
                      : ""}    
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Income Statement Report")
                    ? managePageHrefLinkMobile(
                        "/dashboard/income-statement-reports",
                        _t(t("Income Statement Report"))
                      )
                    : ""}
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Expense Report")
                    ? managePageHrefLinkMobile(
                        "/dashboard/expense-reports",
                        _t(t("Expense Report"))
                      )
                    : ""}
                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Meezan Report")
                  ? managePageHrefLinkMobile(
                      "/dashboard/meezan-reports",
                      _t(t("Card Discount Report"))
                    )
                  : ""}
                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Cancel Order Report")
                  ? managePageHrefLinkMobile(
                      "/dashboard/cancel-order-reports",
                      _t(t("Cancel Order Report"))
                    )
                  : ""}
                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Cancel Item Report")
                  ? managePageHrefLinkMobile(
                      "/dashboard/cancel-made-unmade-reports",
                      _t(t("Cancel Item Report (Made/Unmade)"))
                    )
                  : ""}
                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Hourly Sales Report")
                  ? managePageHrefLinkMobile(
                      "/dashboard/hourly-sales-reports",
                      _t(t("Hourly Sales Report"))
                    )
                  : ""}
               
                {authUserInfo.permissions !== null &&
                checkPermission(
                  authUserInfo.permissions,
                  "Daily Cash Sales Report"
                )
                  ? managePageHrefLinkMobile(
                      "/dashboard/daily-cash-sales-reports",
                      _t(t("Daily Cash Sales Report"))
                    )
                  : ""}

                {/* yearly */}
                {/* {managePageHrefLink(
                  "/dashboard/yearly-reports",
                  _t(t("Yearly"))
                )} */}

                {/* food item wise */}
                {authUserInfo.permissions !== null &&
                checkPermission(
                  authUserInfo.permissions,
                  "Item Food Cost Report"
                )
                  ? managePageHrefLinkMobile(
                      "/dashboard/food-items-reports",
                      _t(t("Item Food Cost"))
                    )
                  : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(
                  authUserInfo.permissions,
                  "Item Food Cost Report"
                )
                  ? managePageHrefLinkMobile(
                      "/dashboard/ingredient-cost-reports",
                      _t(t("Ingredient Item Cost"))
                    )
                  : ""}

                {/* food group wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Group Wise Report") ? (
                  //   managePageHrefLinkMobile(
                  //   "/dashboard/food-group-reports",
                  //   _t(t("Group Wise"))
                  // )):
                  // ""
                }

                {/* branch wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Branch Wise Report") ? (
                  //   managePageHrefLinkMobile(
                  //   "/dashboard/branch-reports",
                  //   _t(t("Branch Wise"))
                  // )):
                  // ""
                }

                {/* pos user wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Pos User Wise Report") ? (
                  //     managePageHrefLinkMobile(
                  //   "/dashboard/pos-user-reports",
                  //   _t(t("Pos User Wise"))
                  // )):
                  // ""
                }

                {/* food item wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Department Wise Report") ? (
                  //     managePageHrefLinkMobile(
                  //   "/dashboard/dept-tag-reports",
                  //   _t(t("Department Wise"))
                  // )):
                  // ""
                }

                {/* Service charge wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Service Charge Wise Report") ? (
                  //   managePageHrefLinkMobile(
                  //   "/dashboard/service-charge-reports",
                  //   _t(t("Service Charge Wise"))
                  // )):
                  // ""
                }

                {/* discount charge wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Discount Wise Report") ? (
                  //   managePageHrefLinkMobile(
                  //   "/dashboard/discount-reports",
                  //   _t(t("discount Wise"))
                  // )):
                  // ""
                }

                {/* {managePageHrefLinkMobile(
                  "/dashboard/food-stock",
                  _t(t("Food Stock"))
                )}
                {managePageHrefLinkMobile(
                  "/dashboard/ingredient-stock",
                  _t(t("Ingredient Stock"))
                )} */}

                {/* discount charge wise */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Discount Wise Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/discount-reports",
                  _t(t("Discount Report"))
                ) : ""}

                {/* combined discount report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Discount Wise Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/combined-discount-reports",
                  _t(t("Combined Discount Report"))
                ) : ""}

                {/* discount charge wise */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Tender Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/sales-tender-reports",
                  _t(t("Sales Tender Report"))
                ) : ""}

                {
                  showManageStock ? (
                    <>
                      {/* fg ledger */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/finished-goods-ledger-reports",
                        _t(t("Finished Goods Ledger"))
                      ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Movement Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-movement-reports",
                        _t(t("FG Movement Summary Report"))
                      ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-reports",
                        _t(t("FG Report"))
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "FG Purchase Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/fg-purchase-reports",
                          _t(t("FG Purchase Report"))
                        ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Transfer Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-transfer-reports",
                        _t(t("FG Transfer Report"))
                      ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Discard Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-discard-reports",
                        _t(t("FG Discard Report"))
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/grn-reports",
                        _t(t("GRN Report"))
                      ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Packing Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-packing-reports",
                        _t(t("FG Packing Report"))
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Adjustment Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-adjustment-reports",
                        _t(t("FG Adjustment Report"))
                        ) : ""} 
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Hamper Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/gift-hamper-reports",
                        _t(t("Gift Hamper Report"))
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Packing Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/fg-sale-oir-reports",
                        _t(t("Fg Sale OIR Report"))
                      ):""}
      
                      {/* inventory */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Inventory Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/inventory-reports",
                        _t(t("Inventory Report"))
                      ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Ingredient Item Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/ingredient-item-reports",
                        _t(t("Ingredient Item"))
                      ):""}
      
                      {/* stock ledger */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Ledger Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/stock-ledger-reports",
                        _t(t("Stock Ledger"))
                      ):""}

                      {/* Multi Branch Analysis */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Ledger Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/multi-branch-analysis-reports",
                        _t(t("Multi Branch Analysis"))
                      ):""}

                      {/* stock movemnt */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Raw Movement Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/raw-movement-reports",
                        _t(t("Raw Movement Report"))
                      ):""}


                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Ingredient Consumption Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/ingredient-consumption-reports",
                        _t(t("Ingredient Consumption Report"))
                      ):""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Ingredient Conversion Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/ingredient-conversion-reports",
                        _t(t("Ingredient Conversion Report"))
                        ) : ""}  

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Opening Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/opening-reports",
                        _t(t("Opening Report"))
                        ) : ""}  
      
                      {/* stock variance */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Variance Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/stock-variance-reports",
                        _t(t("Stock Variance"))
                      ):""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Consumption Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/stock-consumption-reports",
                        _t(t("Stock Consumption"))
                      ):""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Consumption Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/consumption-purchase-variance-reports",
                        _t(t("Consumption Purchase Variance"))
                      ):""}

                      {authUserInfo.permissions !== null &&
                        (checkPermission(
                          authUserInfo.permissions,
                          "Stock Variance Report"
                        ) ||
                          checkPermission(authUserInfo.permissions, "Report")) ?
                        managePageHrefLinkMobile(
                          "/dashboard/actual-ideal-cost-reports",
                          _t(t("Ideal vs Actual Cost Report"))
                        ) : ""}
      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                          managePageHrefLinkMobile(
                          "/dashboard/stock-transfer-reports",
                          _t(t("Stock Transfer"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Closing Stock Report"
                        ) ?
                          managePageHrefLinkMobile(
                          "/dashboard/closing-stock-reports",
                          _t(t("Closing Stock Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Report"
                        ) ?
                          managePageHrefLinkMobile(
                          "/dashboard/purchase-return-report",
                          _t(t("Purchase Return Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "RCR Audit Report"
                        ) ?
                          managePageHrefLinkMobile(
                          "/dashboard/rcr-reports",
                          _t(t("RCR Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Adjustment Report"
                        ) ?
                          managePageHrefLinkMobile(
                          "/dashboard/stock-adjustment-reports",
                          _t(t("Stock Adjustment"))
                        ) : ""}  
      

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                          managePageHrefLinkMobile(
                          "/dashboard/stock-issuance-reports",
                          _t(t("Stock Issuance"))
                        ) : ""}  

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                        managePageHrefLinkMobile(
                          "/dashboard/store-requisition-reports",
                          _t(t("Store Requisition Report"))
                        ) : ""}  
      
      
                      {/* stock tranfer */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Raw Stock Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/stock-transfer-raw-reports",
                        _t(t("Raw Stock Transfer"))
                      ):""}

                      {authUserInfo.permissions !== null &&
                      checkPermission(
                        authUserInfo.permissions,
                        "Ingredient Cost Report"
                      ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/food-cost-reports",
                        _t(t("Ingredient Cost Report"))
                      ):""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Wastage Report"
                        ) ?
                        managePageHrefLinkMobile(
                        "/dashboard/wastage-reports",
                        _t(t("Wastage Report"))
                      ):""}
                    </> 
                  ) : ""
                }

                {/* supplier ledger */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Supplier Ledger Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/supplier-ledger-reports",
                  _t(t("Supplier Ledger"))
                ):""}
                
                {/* Purchase invoice report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Purchase Invoice Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/purchase-invoice-reports",
                  _t(t("Purchase Invoice Report"))
                ) : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Report"
                  )
                  ? managePageHrefLinkMobile(
                    "/dashboard/supplier-purchase-reports",
                    _t(t("Supplier Purchase Report"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Supplier Ledger Report"
                  )
                  ? managePageHrefLinkMobile(
                    "/dashboard/reports/invoice-ageing-report",
                    _t(t("Invoice Ageing Report"))
                  )
                  : ""}


                {/* Po To Pi Report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Po To Pi Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/po-to-pi-report",
                  _t(t("Po To Pi Report"))
                ) : ""}

                {/* sale invoice report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sale Invoice Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/sale-invoice-reports",
                  _t(t("Sale Invoice Report"))
                ) : ""}

                {/* fg sale invoice report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "FG Sale Invoice Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/fg-sale-invoice-reports",
                  _t(t("FG Sale Invoice Report"))
                ) : ""}

                {/* sale return report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sale Return Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/sale-return-reports",
                  _t(t("Sale Return Report"))
                ) : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "MS Bank Drop Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/bank-drop-reports",
                  _t(t("Bank Drop Report"))
                ) : ""}

                {
                  getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none" ? (
                    <>
                    {/* loyalty report */}
                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Loyalty Report")
                      ? managePageHrefLinkMobile(
                        "/dashboard/work-period-reports",
                        _t(t("Loyalty Overview Report"))
                      )
                      : ""}

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Loyalty Report")
                      ? managePageHrefLinkMobile(
                        "/dashboard/work-period-reports",
                        _t(t("Customer Loyalty Activity Report"))
                      )
                      : ""}

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Loyalty Report")
                      ? managePageHrefLinkMobile(
                        "/dashboard/work-period-reports",
                        _t(t("Redemption Report"))
                      )
                      : ""}  

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Loyalty Report")
                      ? managePageHrefLinkMobile(
                        "/dashboard/work-period-reports",
                        _t(t("Loyalty Performance Report"))
                      )
                      : ""}    

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Loyalty Report")
                      ? managePageHrefLinkMobile(
                        "/dashboard/work-period-reports",
                        _t(t("Customer Activity Report"))
                      )
                      : ""}
                    </>
                  ) : ""
                }

                {/* srb report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "SRB Report"
                  ) ?
                  managePageHrefLinkMobile(
                  "/dashboard/srb-report",
                  _t(t("SRB Report"))
                ):""}

                {/* Production Report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Production Report"
                  ) ?
                  managePageHrefLinkMobile(
                    "/dashboard/production-reports",
                    _t(t("Production Report"))
                  ) : ""}

                {/* recipe Report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Recipe Report"
                  ) ?
                  managePageHrefLinkMobile(
                    "/dashboard/recipe-reports",
                    _t(t("Recipe Report"))
                  ) : ""}

                {/*customer report*/}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Customer Report"
                  )
                  ? managePageHrefLinkMobile(
                    "/dashboard/customer-report",
                    _t(t("Customer Report"))
                  )
                  : ""}

              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation for Small Screen  End*/}

      {/* Navigation for large Screen  */}
      <div className="d-none d-lg-block">
        {renderSearchBar(false)}

        {searchTerm.trim() && matchCount === 0 && (
          <div className="text-center py-4 px-3 bg-white rounded border my-2 shadow-sm">
            <div className="mb-2">
              <i className="fa fa-search text-muted" style={{ fontSize: "22px" }}></i>
            </div>
            <p className="text-dark font-weight-bold mb-1" style={{ fontSize: "13px" }}>
              {_t(t("No reports found"))}
            </p>
            <p className="text-muted mb-3" style={{ fontSize: "11.5px" }}>
              {_t(t("No reports match"))} "{searchTerm}"
            </p>
            <button
              type="button"
              className="btn btn-sm btn-outline-danger px-3 py-1 font-weight-bold"
              style={{ fontSize: "11px", borderRadius: "20px" }}
              onClick={() => setSearchTerm("")}
            >
              <i className="fa fa-times mr-1"></i> {_t(t("Clear Search"))}
            </button>
          </div>
        )}

        <div
          className="fk-scroll--pos-menu report-sidebar-scroll"
          style={{ display: searchTerm.trim() && matchCount === 0 ? "none" : undefined }}
        >
          <ul className="t-list fk-pos-nav">
            {/* Dashboard */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname === '/dashboard/reports' || window.location.pathname === '/dashboard/consolidated-reports' ||  window.location.pathname === "/dashboard/table-view" ||
               window.location.pathname === '/dashboard/consolidate-reports' || window.location.pathname === "/dashboard/costing-reports" || window.location.pathname === "/dashboard/production-dashboard" || window.location.pathname === '/dashboard/admin-reports' ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Dashboard"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                {hasDashboardPermission && (
                    managePageHrefLink(
                    "/dashboard/reports",
                    _t(t("Dashboard"))
                  )
                )}

                {hasTableViewPermission && (
                    managePageHrefLink(
                    "/dashboard/table-view",
                    _t(t("Table View"))
                  )
                )}

                {
                  authUserInfo?.details && (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") && (
                    managePageHrefLink(
                      "/dashboard/admin-reports",
                      _t(t("Admin Dashboard"))
                    )
                  )
                }

                {
                  authUserInfo?.details && (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") && (
                    managePageHrefLink(
                      "/dashboard/costing-reports",
                      _t(t("Costing Dashboard"))
                    )
                  )
                }
                {authUserInfo?.details && authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" ? (
                  <>
                    {/*production dashboard */}
                    {authUserInfo && (authUserInfo.details.user_type === "superAdmin" ||
                    authUserInfo.details.user_type === "admin") && managePageHrefLink(
                     "/dashboard/production-dashboard",
                     _t(t("Production Dashboard"))
                   )}
                    {/*consolited dashboard */}
                    {authUserInfo && authUserInfo.details.user_type === "superAdmin" &&
                      getSystemSettings(generalSettings, "call_api") === "yes" && managePageHrefLink(
                        "/dashboard/consolidated-reports",
                        _t(t("Consolidate Dashboard"))
                      )}

                    {/*consolited dashboard */}
                    {authUserInfo && authUserInfo.details.user_type === "superAdmin" &&
                      getSystemSettings(generalSettings, "call_api") === "yes" && managePageHrefLink(
                        "/dashboard/consolidate-reports",
                        _t(t("Consolidate Report"))
                      )}

                    {/* daily */}

                    {/* {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Daily Report")
                      ? managePageHrefLink(
                          "/dashboard/daily-reports",
                          _t(t("Daily"))
                        )
                      : ""} */}

                    {/* monthly */}
                    {/* {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Monthly Report")
                      ? managePageHrefLink(
                          "/dashboard/monthly-reports",
                          _t(t("Monthly"))
                        )
                      : ""} */}
                  </>
                ) : null}
              </ul>
            </li>

            {/* Sales Reports */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${(window.location.pathname.includes("sale") || window.location.pathname.includes("order-tracking-reports")) ||
                window.location.pathname.includes("srb") || window.location.pathname.includes("foc") || window.location.pathname.includes("deal") ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Sales Reports"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Sales Report")
                  ? managePageHrefLink(
                    "/dashboard/sales-reports",
                    _t(t("Sales Report"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Summary Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/sales-summary-reports",
                    _t(t("Sales Summary Report"))
                  )
                  : ""}

                {/* weekly sales report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Summary Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/weekly-sales-reports",
                    _t(t("Weekly Sales Report"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Foc Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/foc-reports",
                    _t(t("Foc Report"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Sales Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/sales-analysis-reports",
                    _t(t("Sales Analysis Report"))
                  )
                  : ""}

                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Gross Sales Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/gross-sales-reports",
                    _t(t("Gross Sales Report"))
                  )
                  : ""}
                    
                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Tax Report"
                  )
                  ? managePageHrefLink(
                      "/dashboard/tax-sales-reports",
                      _t(t("Tax Report"))
                    )
                  : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Order Tracking Report")
                    ? managePageHrefLink(
                      "/dashboard/order-tracking-reports",
                      _t(t("Order Tracking Report"))
                    )
                    : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(authUserInfo.permissions, "Hourly Sales Report")
                    ? managePageHrefLink(
                      "/dashboard/hourly-sales-reports",
                      _t(t("Hourly Sales Report"))
                    )
                    : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "Deals Report"
                    )
                    ? managePageHrefLink(
                      "/dashboard/deal-reports",
                      _t(t("Deal's Report"))
                    )
                    : ""}

                  {/* srb report */}
                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "SRB Report"
                    ) ?
                    managePageHrefLink(
                      "/dashboard/srb-reports",
                      _t(t("SRB Report"))
                    ) : ""}

                  {/* Tender Report */}
                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "Sales Tender Report"
                    ) ?
                    managePageHrefLink(
                      "/dashboard/sales-tender-reports",
                      _t(t("Sales Tender Report"))
                    ) : ""}
              </ul>
            </li>

            {
              showManageStock ? (
                <>
                  {/* Finished Goods */}
                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("fg") || window.location.pathname.includes("gift") || window.location.pathname.includes("goods") ? "active" : ""
                    }`}
                  >
                    <a
                      className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                      rel="noopener noreferrer"
                      href="#"
                    >
                      {_t(t("FG Reports"))}
                    </a>
                    <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                      {/* fg ledger */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/finished-goods-ledger-reports",
                          _t(t("Finished Goods Ledger"))
                        ) : ""}

                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Finished Goods Movement Report"
                          ) ?
                          managePageHrefLink(
                            "/dashboard/fg-movement-reports",
                            _t(t("FG Movement Report"))
                          ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/fg-reports",
                          _t(t("FG Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "FG Purchase Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/fg-purchase-reports",
                          _t(t("FG Purchase Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Transfer Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/fg-transfer-reports",
                          _t(t("FG Transfer Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Discard Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/fg-discard-reports",
                          _t(t("FG Discard Report"))
                        ) : ""}

                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Finished Goods Packing Report"
                          ) ?
                          managePageHrefLink(
                            "/dashboard/fg-packing-reports",
                            _t(t("FG Packing Report"))
                          ) : ""}

                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Finished Goods Packing Report"
                          ) ?
                          managePageHrefLink(
                          "/dashboard/fg-sale-oir-reports",
                          _t(t("Fg Sale OIR Report"))
                          ) : ""} 

                       {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Finished Goods Adjustment Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/fg-adjustment-reports",
                        _t(t("FG Adjustment Report"))
                         ) : ""} 

                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Finished Goods Hamper Report"
                          ) ?
                          managePageHrefLink(
                            "/dashboard/gift-hamper-reports",
                            _t(t("Gift Hamper Report"))
                          ) : ""}
                    </ul>
                  </li>

                  {/* Stock Reports */}
                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${(!window.location.pathname.includes("ingredient-report")) && (window.location.pathname.includes("ingredient") || window.location.pathname.includes("stock") || window.location.pathname.includes("supplier-ledger") ||
                      window.location.pathname.includes("raw-movement-reports") || window.location.pathname.includes("actual-ideal-cost") || window.location.pathname.includes("purchase-return-report") || window.location.pathname.includes("production-reports") || window.location.pathname.includes("rcr-reports") || window.location.pathname.includes("recipe")) ? "active" : ""
                    }`}
                  >
                    <a
                      className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                      rel="noopener noreferrer"
                      href="#"
                    >
                      {_t(t("Stock Reports"))}
                    </a>
                    <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                      {/* inventory */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Inventory Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/inventory-reports",
                          _t(t("Inventory Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Ingredient Item Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/ingredient-item-reports",
                          _t(t("Ingredient Item"))
                        ) : ""}

                      {/* stock ledger */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Ledger Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-ledger-reports",
                          _t(t("Stock Ledger"))
                        ) : ""}

                      {/* stock movement */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Raw Movement Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/raw-movement-reports",
                          _t(t("Raw Movement Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Ingredient Consumption Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/ingredient-consumption-reports",
                        _t(t("Ingredient Consumption Report"))
                        ) : ""} 
                        
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Ingredient Conversion Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/ingredient-conversion-reports",
                        _t(t("Ingredient Conversion Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Opening Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/opening-reports",
                        _t(t("Opening Report"))
                        ) : ""}

                      {/* stock variance */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Variance Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-variance-reports",
                          _t(t("Stock Variance"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Consumption Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-consumption-reports",
                          _t(t("Stock Consumption"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Consumption Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/consumption-purchase-variance-reports",
                          _t(t("Consumption Purchase Variance"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        (checkPermission(
                          authUserInfo.permissions,
                          "Stock Variance Report"
                        ) ||
                          checkPermission(authUserInfo.permissions, "Report")) ?
                        managePageHrefLink(
                          "/dashboard/actual-ideal-cost-reports",
                          _t(t("Ideal vs Actual Cost Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-transfer-reports",
                          _t(t("Stock Transfer"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-issuance-reports",
                          _t(t("Stock Issuance"))
                        ) : ""}  

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/store-requisition-reports",
                          _t(t("Store Requisition"))
                        ) : ""}  


                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-adjustment-reports",
                          _t(t("Stock Adjustment"))
                        ) : ""}
                        
                      {/* wastage Report */}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Recipe Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/wastage-reports",
                          _t(t("Wastage Report"))
                        ) : ""} 

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Stock Transfer Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/closing-stock-reports",
                          _t(t("Closing Stock Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/purchase-return-report",
                          _t(t("Purchase Return Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "RCR Audit Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/rcr-reports",
                          _t(t("RCR Report"))
                        ) : ""}


                      {/* stock transfer */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Raw Stock Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/stock-transfer-raw-reports",
                          _t(t("Raw Stock Transfer"))
                        ) : ""}
                      
                      {/* supplier ledger */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Supplier Ledger Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/supplier-ledger-reports",
                          _t(t("Supplier Ledger"))
                        ) : ""}  

                      {/* Production Report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Production Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/production-reports",
                          _t(t("Production Report"))
                        ) : ""}

                      {/* recipe Report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Recipe Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/recipe-reports",
                          _t(t("Recipe Report"))
                        ) : ""}

                    </ul>
                  </li>

                  {/* purchase Reports */}
                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${(window.location.pathname.includes("grn-reports") || window.location.pathname.includes("po-to-pi") || window.location.pathname.includes("purchase-invoice") || window.location.pathname.includes("supplier-purchase-reports")||
                      window.location.pathname.includes("sale-invoice") || window.location.pathname.includes("purchase-order") ||  window.location.pathname.includes("purchase-request")) || window.location.pathname.includes("bank-drop-reports") ? "active" : ""
                    }`}
                  >
                    <a
                      className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                      rel="noopener noreferrer"
                      href="#"
                    >
                      {_t(t("Purchase Reports"))}
                    </a>
                    <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Purchase Request Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/purchase-request-reports",
                          _t(t("Purchase Request Report"))
                        ) : ""} 

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Purchase Order Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/purchase-order-reports",
                          _t(t("Purchase Order Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Sales Report"
                        )
                        ? managePageHrefLink(
                          "/dashboard/supplier-purchase-reports",
                          _t(t("Supplier Purchase Report"))
                        )
                        : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Supplier Ledger Report"
                        )
                        ? managePageHrefLink(
                          "/dashboard/reports/invoice-ageing-report",
                          _t(t("Invoice Ageing Report"))
                        )
                        : ""}

                      {/* GRN report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Goods Recieved Note Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/grn-reports",
                          _t(t("GRN Report"))
                        ) : ""}   

                      {/* Purchase invoice report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Purchase Invoice Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/purchase-invoice-reports",
                        _t(t("Purchase Invoice Report"))
                        ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Po To Pi Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/po-to-pi-report",
                        _t(t("Po To Pi Report"))
                      ) : ""}

                      {/* sale invoice report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Sale Invoice Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/sale-invoice-reports",
                        _t(t("Sale Invoice Report"))
                        ) : ""}

                      {/* fg sale invoice report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "FG Sale Invoice Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/fg-sale-invoice-reports",
                        _t(t("FG Sale Invoice Report"))
                      ) : ""}  

                      {/* sale return report */}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Sale Return Report"
                        ) ?
                        managePageHrefLink(
                        "/dashboard/sale-return-reports",
                        _t(t("Sale Return Report"))
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Bank Drop Report"
                        ) ?
                        managePageHrefLink(
                          "/dashboard/bank-drop-reports",
                          _t(t("Bank Drop Report"))
                        ) : ""}
                     
                    </ul>
                  </li>
                </> 
              ) : ""
            }

            {/* Discount Reports */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${(window.location.pathname.includes("meezan") || window.location.pathname.includes("discount")) ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Discount Reports"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Meezan Report")
                  ? managePageHrefLink(
                    "/dashboard/meezan-reports",
                    _t(t("Card Discount Report"))
                  )
                  : ""}

                {/* discount charge wise */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Discount Wise Report"
                  ) ?
                  managePageHrefLink(
                    "/dashboard/discount-reports",
                    _t(t("Discount Report"))
                  ) : ""}

                {/* combined discount report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Discount Wise Report"
                  ) ?
                  managePageHrefLink(
                    "/dashboard/combined-discount-reports",
                    _t(t("Combined Discount Report"))
                  ) : ""}
              </ul>
            </li>

            {/*loyality report */}
            {
              parseInt(getSystemSettings(generalSettings, "loyality_enable")) === 1 ? (
                <li
                  className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("reports") && window.location.pathname !== '/dashboard/admin-reports' && window.location.pathname !== '/dashboard/consolidated-reports' && window.location.pathname !== '/dashboard/consolidate-reports' && window.location.pathname !== '/dashboard/reports' && (!window.location.pathname.includes("fg") && window.location.pathname.includes("loyality")) ? "active" : ""
                  }`}
                >
                  <a
                    className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                    rel="noopener noreferrer"
                    href="#"
                  >
                    {_t(t("Loyalty Reports"))}
                  </a>
                  <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Loyalty Overview Report"))
                      )
                      : ""}
                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Customer Activity Report"))
                      )
                      : ""} 
                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Points Balance Report"))
                      )
                      : ""} 

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Redemption Report"))
                      )
                      : ""} 

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Customer Retention Report"))
                      )
                      : ""} 

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Customer Activity Report"))
                      )
                      : ""} 

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Sales Impact Report"))
                      )
                      : ""}  

                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Sales Report")
                      ? managePageHrefLink(
                        "/dashboard/work-period-reports",
                        _t(t("Loyalty Performance Report"))
                      )
                      : ""}           
                        
                  </ul> 
                </li>  
              ) : ""
            }

            {/* Others */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("reports") && window.location.pathname !== '/dashboard/admin-reports' && window.location.pathname !== '/dashboard/consolidated-reports' && window.location.pathname !== '/dashboard/consolidate-reports'&& window.location.pathname !== '/dashboard/reports' && window.location.pathname !== '/dashboard/supplier-purchase-reports' && window.location.pathname !== '/dashboard/actual-ideal-cost-reports' && (!window.location.pathname.includes("fg") && !window.location.pathname.includes("goods"))
                && !window.location.pathname.includes("sales") && (!window.location.pathname.includes("ingredient") && !window.location.pathname.includes("grn-report") && !window.location.pathname.includes("srb") && !window.location.pathname.includes("production") && !window.location.pathname.includes("inventory") && !window.location.pathname.includes("stock") && !window.location.pathname.includes("purchase-invoice"))
                && (!window.location.pathname.includes("meezan") && !window.location.pathname.includes("discount") && !window.location.pathname.includes("deal") && !window.location.pathname.includes("supplier-ledger") && !window.location.pathname.includes("gift") && !window.location.pathname.includes("recipe")) && !window.location.pathname.includes("order-tracking-reports") && !window.location.pathname.includes("bank-drop-reports") ? "active" : ""
                }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Other Reports"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                {/* monthly */}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Work Period Report")
                  ? managePageHrefLink(
                    "/dashboard/work-period-reports",
                    _t(t("Work Period Report"))
                  )
                  : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Menu Mix Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/menu-mix-reports",
                    _t(t("Menu Mix Report"))
                  )
                  : ""}

                {/* Multi Branch Analysis */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Stock Ledger Report"
                  ) ?
                  managePageHrefLink(
                    "/dashboard/multi-branch-analysis-reports",
                    _t(t("Multi Branch Analysis"))
                  ) : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Callcenter Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/call-center-reports",
                    _t(t("Call Center Report"))
                  )
                  : ""}
                {/* monthly */}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Source Wise Report")
                  ? managePageHrefLink(
                    "/dashboard/source-reports",
                    _t(t("Source Wise Report"))
                  )
                  : ""}
                {/* monthly */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Customer Order History Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/customer-order-reports",
                    _t(t("Customer Order Report"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Food Panda Report")
                  ? managePageHrefLink(
                    "/dashboard/food-panda-reports",
                    _t(t("Food Panda Report"))
                  )
                  : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Feedback Report")
                  ? managePageHrefLink(
                    "/dashboard/feedback-reports",
                    _t(t("Feedback Report"))
                  )
                  : ""}  
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Rider Report")
                  ? managePageHrefLink(
                    "/dashboard/rider-reports",
                    _t(t("Rider Report"))
                  )
                  : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Waiter Report")
                  ? managePageHrefLink(
                    "/dashboard/waiter-reports",
                    _t(t("Waiter Report"))
                  )
                  : ""}  
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Income Statement Report")
                  ? managePageHrefLink(
                    "/dashboard/income-statement-reports",
                    _t(t("Income Statement Report"))
                  )
                  : ""}
                
                {/* Commission Report */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Expense Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/commission-reports",
                    _t(t("Commission Report"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Expense Report")
                  ? managePageHrefLink(
                    "/dashboard/expense-reports",
                    _t(t("Expense Report"))
                  )
                  : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Cancel Order Report")
                  ? managePageHrefLink(
                    "/dashboard/cancel-order-reports",
                    _t(t("Cancel Order Report"))
                  )
                  : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Cancel Item Report")
                  ? managePageHrefLink(
                    "/dashboard/cancel-made-unmade-reports",
                    _t(t("Cancel Item Report (Made/Unmade)"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Daily Cash Sales Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/daily-cash-sales-reports",
                    _t(t("Daily Cash Sales Report"))
                  )
                  : ""}

                {/* yearly */}
                {/* {managePageHrefLink(
                  "/dashboard/yearly-reports",
                  _t(t("Yearly"))
                )} */}

                {/* food item wise */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Item Food Cost Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/food-items-reports",
                    _t(t("Item Food Cost"))
                  )
                  : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(
                  authUserInfo.permissions,
                  "Item Food Cost Report"
                )
                  ? managePageHrefLink(
                      "/dashboard/ingredient-cost-reports",
                      _t(t("Ingredient Item Cost"))
                    )
                  : ""}

                {/* food group wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Group Wise Report") ? (
                  //   managePageHrefLink(
                  //   "/dashboard/food-group-reports",
                  //   _t(t("Group Wise"))
                  // )):
                  // ""
                }

                {/* branch wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Branch Wise Report") ? (
                  //   managePageHrefLink(
                  //   "/dashboard/branch-reports",
                  //   _t(t("Branch Wise"))
                  // )):
                  // ""
                }

                {/* pos user wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Pos User Wise Report") ? (
                  //   managePageHrefLink(
                  //   "/dashboard/pos-user-reports",
                  //   _t(t("Pos User Wise"))
                  // )):
                  // ""
                }

                {/* food item wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Department Wise Report") ? (
                  //   managePageHrefLink(
                  //   "/dashboard/dept-tag-reports",
                  //   _t(t("Department Wise"))
                  // )):
                  // ""
                }

                {/* Service charge wise */}
                {
                  //   authUserInfo.permissions !== null &&
                  //   checkPermission(authUserInfo.permissions, "Service Charge Wise Report") ? (
                  //   managePageHrefLink(
                  //   "/dashboard/service-charge-reports",
                  //   _t(t("Service Charge Wise"))
                  // )):
                  // ""
                }
              </ul>
            </li>

            {/*master report */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("item") || window.location.pathname.includes("ingredient-report") || window.location.pathname.includes("customer-report") ? "active" : ""
                }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Master Reports"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

                {/* food item */}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Food Item Report")
                  ? managePageHrefLink(
                    "/dashboard/all-item-report",
                    _t(t("Food Item"))
                  )
                  : ""}
                  {/*ingredient item*/}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Ingredient Item Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/ingredient-report",
                    _t(t("Ingredient Item Report"))
                  )
                  : ""}

                {/*customer report*/}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Customer Report"
                  )
                  ? managePageHrefLink(
                    "/dashboard/customer-report",
                    _t(t("Customer Report"))
                  )
                  : ""}
              </ul>
            </li>

          </ul>
        </div>
      </div>
      {/* Navigation for large Screen End */}
    </>
  );
};

export default ReportSidebar;
